import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PixTransferSteps } from '../../components/PixTransferSteps/PixTransferSteps';
import styles from './PixTransfer.module.css';
export function PixTransfer() {
    const dataTestId = 'conta-pj-pix-transfer';
    return (_jsx("main", { className: styles.main, "data-testid": dataTestId, children: _jsx(PixTransferSteps, { dataTestId: `${dataTestId}-steps-page` }) }));
}
